import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CreditCard icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CreditCard } from '@sravni/design-system-icons'
 *
 * <CreditCard />
 * ```
 */
var CreditCard = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CreditCard", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.5 7.5h15M7.975 10.833H5.833M15 15.833H5a2.5 2.5 0 0 1-2.5-2.5V6.667a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v6.666a2.5 2.5 0 0 1-2.5 2.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CreditCard };
//# sourceMappingURL=CreditCard.js.map
